/**
 * @param {any} draft - Draft state.
 */
export const setResetFilters = (draft) => {
    // eslint-disable-next-line guard-for-in
    for (let key in draft.filters) {
        draft.filters[key] = [];
    }
};
